import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "step" }
const _hoisted_2 = { class: "step-header" }
const _hoisted_3 = { class: "step-icon" }
const _hoisted_4 = { class: "step-content" }
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = {
  key: 0,
  class: "api-error"
}
const _hoisted_7 = {
  key: 0,
  class: "existing-secret"
}
const _hoisted_8 = { class: "existing-secret__value" }

import { ref, watch } from "vue";
import AppTextField from "@/shared/components/ui/AppTextField.vue";
import { useModalStore } from "@/shared/stores/modal";
import StripeCredentialsGuideModal from "@/modules/vendor/components/profile-setup/StripeCredentialsGuideModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentCredentialsStep',
  props: {
    current_step: {},
    errors: {},
    profileInfo: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const modal = useModalStore();

const publicKey = ref("");
const secretKey = ref("");
const credentialName = ref("Stripe Account");
const existingWebhookSecret = ref("");

const publicKeyError = ref("");
const secretKeyError = ref("");
const credentialNameError = ref("");
const genericError = ref("");

function getValues() {
  return {
    name: credentialName.value,
    publicKey: publicKey.value,
    secretKey: secretKey.value,
  };
}

__expose({ getValues });

function openGuide() {
  modal.open(
    StripeCredentialsGuideModal,
    {},
    { fullscreen: true, title: "Stripe setup guide", showHeader: false }
  );
}

watch(
  () => props.profileInfo,
  (info) => {
    const creds = info?.payment_credentials?.credentials || null;
    if (!creds) return;
    const name = info?.payment_credentials?.name ?? "";

    // Prefill only when the user hasn't typed anything yet.
    if (
      typeof name === "string" &&
      name.trim() &&
      (!credentialName.value || credentialName.value === "Stripe Account")
    ) {
      credentialName.value = name;
    }
    if (!publicKey.value && typeof creds.publishable_key === "string") {
      publicKey.value = creds.publishable_key;
    }
    if (!secretKey.value && typeof creds.secret_key === "string") {
      secretKey.value = creds.secret_key;
    }
    if (typeof creds.webhook_secret === "string" && creds.webhook_secret.trim()) {
      existingWebhookSecret.value = creds.webhook_secret.trim();
    } else if (!info?.payment_credentials) {
      existingWebhookSecret.value = "";
    }
  },
  { immediate: true }
);

function friendlyMessageFor(key: string, raw: string) {
  const msg = String(raw || "");
  // If API indicates required, make a user-friendly message
  if (/required/i.test(msg)) {
    if (/(publishable|public)/i.test(key)) return "Publishable key is required.";
    if (/(secret_key|secret)/i.test(key)) return "Secret key is required.";
  }
  // fallback: return raw message
  return msg;
}

// Map incoming API errors to local fields, including nested keys like credentials.publishable_key
watch(
  () => props.errors,
  (errs: any) => {
    publicKeyError.value = "";
    secretKeyError.value = "";
    credentialNameError.value = "";
    genericError.value = "";
    if (!errs) return;

    Object.entries(errs).forEach(([k, v]) => {
      const raw = Array.isArray(v) ? v.join(" ") : String(v ?? "");
      const keyPart = k.includes(".") ? k.split(".").pop() || k : k;
      const key = String(keyPart);
      const lower = key.toLowerCase();
      const friendly = friendlyMessageFor(lower, raw);

      if (/^name$/i.test(lower)) {
        credentialNameError.value = friendly;
      } else if (/(publishable|public)/i.test(lower)) {
        publicKeyError.value = friendly;
      } else if (/(secret_key|secret)/i.test(lower)) {
        secretKeyError.value = friendly;
      } else {
        genericError.value = genericError.value
          ? `${genericError.value} ${friendly}`
          : friendly;
      }
    });
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_icon, {
          size: "24",
          color: "#e8612f"
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode("mdi-credit-card-outline", -1)
          ]))]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "title" }, "Stripe credentials", -1)),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "desc-row" }, [
          _createElementVNode("p", { class: "desc" }, "Enter your Stripe keys to enable payments.")
        ], -1)),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_btn, {
            variant: "tonal",
            color: "primary",
            "append-icon": "mdi-information-outline",
            class: "guide-btn",
            onClick: openGuide
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode(" STRIPE SETUP GUIDE ", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    (genericError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(genericError.value), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_v_form, { class: "form" }, {
      default: _withCtx(() => [
        _createVNode(AppTextField, {
          modelValue: credentialName.value,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((credentialName).value = $event)),
            _cache[1] || (_cache[1] = ($event: any) => (credentialNameError.value = ''))
          ],
          autocomplete: "off",
          label: "Payment Gateway",
          "label-icon": "mdi-tag-outline",
          placeholder: "e.g. Primary Stripe Account",
          "error-messages": credentialNameError.value
        }, null, 8, ["modelValue", "error-messages"]),
        _createVNode(AppTextField, {
          modelValue: publicKey.value,
          "onUpdate:modelValue": [
            _cache[2] || (_cache[2] = ($event: any) => ((publicKey).value = $event)),
            _cache[3] || (_cache[3] = ($event: any) => (publicKeyError.value = ''))
          ],
          autocomplete: "off",
          label: "Publishable key",
          "label-icon": "mdi-key-outline",
          placeholder: "pk_...",
          "error-messages": publicKeyError.value
        }, null, 8, ["modelValue", "error-messages"]),
        _createVNode(AppTextField, {
          modelValue: secretKey.value,
          "onUpdate:modelValue": [
            _cache[4] || (_cache[4] = ($event: any) => ((secretKey).value = $event)),
            _cache[5] || (_cache[5] = ($event: any) => (secretKeyError.value = ''))
          ],
          autocomplete: "off",
          label: "Secret key",
          "label-icon": "mdi-lock-outline",
          placeholder: "sk_...",
          "error-messages": secretKeyError.value
        }, null, 8, ["modelValue", "error-messages"]),
        (existingWebhookSecret.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "existing-secret__label" }, "Webhook signing secret", -1)),
              _createElementVNode("div", _hoisted_8, _toDisplayString(existingWebhookSecret.value), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})